function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import FiltersComponent from '../../components/Filters/Filters';
import { dataFiltersLoad, dataItemDeselect, dataItemsLoad, deselectAllFilters, toggleFilter, toggleFilterValues } from '../../store/actions/datasetSlice';
import { journeyDeselectStart } from '../../store/actions/navitiaSearch';
import { getHash, setHash } from '../../utils/urlUtils';

/** This component proides the list of filters and all the values inside each available filter */
function Filters(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      var _state$dataset;
      return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : _state$dataset.filters;
    }),
    loading = _useSelector.loading,
    filters = _useSelector.filters,
    selectedValues = _useSelector.selectedValues,
    initialFilters = _useSelector.initialFilters;
  var _useState = useState({}),
    filtersHash = _useState[0],
    setFiltersHash = _useState[1];
  useEffect(function () {
    var hashSelectedValues = getHash('filters');
    dispatch(dataFiltersLoad({
      isInitial: true
    }));
    if (hashSelectedValues) {
      setFiltersHash(hashSelectedValues);
    }
  }, []);
  var handleToggleFilter = function handleToggleFilter(filterKey, value) {
    dispatch(toggleFilter(filterKey, value));
    var hash = _extends({}, filtersHash);
    var filter = hash[filterKey];
    if (filter) {
      if (filter.includes(value) && filter.length === 1) {
        delete hash[filterKey];
      } else if (filter.includes(value)) {
        hash[filterKey].splice(hash[filterKey].indexOf(value), 1);
      } else {
        hash[filterKey].push(value);
      }
    } else {
      hash[filterKey] = [value];
    }
    setFiltersHash(hash);
    setHash('filters', hash);
    setHash('page', '');
  };
  var handleToggleFilterValues = function handleToggleFilterValues(filterKey, values, isRange) {
    dispatch(toggleFilterValues(filterKey, values, isRange));
    var hash = _extends({}, filtersHash);
    var rangeValues = [];
    if (isRange && !values.length && hash[filterKey]) {
      delete hash[filterKey];
    } else {
      values.forEach(function (value) {
        if (hash[filterKey]) {
          if (hash[filterKey].includes(value) && hash[filterKey].length === 1) {
            delete hash[filterKey];
          } else if (hash[filterKey].includes(value) && !isRange) {
            hash[filterKey].splice(hash[filterKey].indexOf(value), 1);
          } else if (isRange) {
            rangeValues.push(value);
          } else {
            hash[filterKey].push(value);
          }
        } else {
          hash[filterKey] = [value];
          if (isRange) {
            rangeValues.push(value);
          }
        }
      });
      if (isRange) {
        hash[filterKey] = rangeValues;
      }
    }
    setFiltersHash(hash);
    setHash('filters', hash);
    setHash('page', '');
  };
  var handleToggleRangeFilterValues = function handleToggleRangeFilterValues(filterKey, startValue, endValue) {
    handleToggleFilterValues(filterKey, startValue && endValue ? [startValue, endValue] : [], true);
  };
  var handleDeselectFilters = function handleDeselectFilters() {
    dispatch(deselectAllFilters());
    dispatch(dataItemDeselect());
    dispatch(journeyDeselectStart());
    dispatch(dataItemsLoad());
    setHash('filters', '');
    setHash('basemap', '');
    setHash('page', '');
    setHash('selectedItem', '');
    setHash('journey', '');
  };
  return /*#__PURE__*/React.createElement(FiltersComponent, _extends({
    loading: loading,
    filters: filters,
    initialFilters: initialFilters,
    selectedValues: selectedValues,
    toggleFilter: function toggleFilter(filterKey, value) {
      return handleToggleFilter(filterKey, value);
    },
    toggleFilterValues: function toggleFilterValues(filterKey, values) {
      return handleToggleFilterValues(filterKey, values);
    },
    removeAllFilters: handleDeselectFilters,
    toggleRangeFilter: handleToggleRangeFilterValues
  }, props));
}
Filters.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A render function that is used to display the a UI based on the provided data and methods.  Either the single function as a child this prop should be provided
   * @function
   * @param {Object} props
   * @param {boolean} props.loading  A loading state identifier
   * @param {Object} props.error An error object if any
   * @param {Object} props.filters The list of all available filter indexes
   * @param {Object} props.initialFilters The list of all available values grouped by all filters
   * @param {Object} props.selectedValues The list of all selected values grouped by all filters
   * @param {Object} methods
   * @param {function} methods.onToggle A method to call when a given filter should toggle a given value
   * @param {function} methods.onToggleValues A method to call when a given filter should toggle given array of multiple values
   * @param {function} methods.removeAllFilters A method to call when all applied filters should be removed
   *  */
  render: PropTypes.func
} : {};
export default Filters;